<div class="outer-container admin-reports-outer-container">
  <app-accordian title="AdHoc Reports">
    
    <!-- AdHoc Reports content -->
  </app-accordian>

  <app-accordian title="Federal Reporting">
<div class="page-wrapper">
    <div class="report-card">
      <div class="state-box" *ngIf="isLoading && !errorMessage">
        <div class="spinner"></div>
        <p class="state-text">Generating embed token and loading report…</p>
      </div>
      <div class="state-box error-box" *ngIf="errorMessage">
        <div class="error-icon">⚠</div>
        <p class="state-text">{{ errorMessage }}</p>
      </div>
      <!-- Power BI report iframe -->
      <powerbi-report
        *ngIf="!errorMessage && isReportReady"
        [embedConfig]="reportConfig"
        [cssClassName]="reportClass"
        [phasedEmbedding]="phasedEmbeddingFlag"
        [eventHandlers]="eventHandlers"
        (embedded)="onReportEmit($event)">
      </powerbi-report>
    </div>
</div>
    <!-- Federal Reporting content -->
  </app-accordian>
</div>
